import React, { useEffect } from "react";
import Buttons from "../Buttons/Buttons";
import Slide from "@material-ui/core/Slide";
import Radio from "@material-ui/core/Radio";
import { Styles } from "../../../styles/QuizStyles";
import checkedImage from "../../../images/checked.svg";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

function ImageRadioButton(props) {
	const style = Styles();
	const { radioData, onRadioBtnChange, index, questionData } = props;
	const reff = React.useRef("");
	const [scrollToEnd, setScrollToEnd] = React.useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (
				reff.current.scrollTop ===
				reff.current.scrollHeight - reff.current.offsetHeight
			) {
				setScrollToEnd(true);
			} else {
				setScrollToEnd(false);
			}
		};
		document
			.getElementById("scrollDiv")
			.addEventListener("scroll", handleScroll, { passive: true });
	}, []);

	return (
		<>
			<Slide
				in={true}
				mountOnEnter
				direction="up"
				unmountOnExit
				style={{ transformOrigin: "0 0 0" }}
				{...(true ? { timeout: 500 } : {})}
			>
				<div className="col-sm-4">
					<span className={style.span}>
						Question
						<span className={style.questionCount}>
							{index + 1} / {questionData.length}
						</span>
					</span>
					<h1
						className={style.h1}
						dangerouslySetInnerHTML={{ __html: radioData.question }}
					></h1>
					<p
						className={style.p}
						dangerouslySetInnerHTML={{ __html: radioData.subhead }}
					></p>
					<div>
						<Buttons
							{...props}
							style={style}
							btnData={radioData}
							className={style.desktop}
						/>
					</div>
				</div>
			</Slide>
			<Slide
				in={true}
				mountOnEnter
				direction="up"
				unmountOnExit
				style={{ transformOrigin: "0 0 0" }}
				{...(true ? { timeout: 1000 } : {})}
			>
				<div className={style.mansonry + " col-sm-8"} id="scrollDiv" ref={reff}>
					<ResponsiveMasonry
						columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
					>
						<div>
							<Masonry columnsCount={2} gutter="10px">
								{radioData.options.map((elem) => (
									<FormControlLabel
										key={elem.id}
										control={
											<Radio
												value={elem.id}
												className={style.root}
												checked={elem.checked}
												onChange={onRadioBtnChange}
											/>
										}
										label={
											<>
												<img
													data-src={elem.option}
													id={elem.id}
													alt="Images"
													src={elem.option}
													style={{
														width: "100%",
														display: "block",
														borderRadius: 5,
													}}
												/>
												<div
													className={
														elem.checked ? style.backdropShow : style.backdrop
													}
												>
													<img
														src={checkedImage}
														alt="Checked Option"
														className={style.checkedImage}
													/>
												</div>
											</>
										}
									/>
								))}
							</Masonry>
							<div>
								<Buttons
									{...props}
									style={style}
									btnData={radioData}
									className={style.mobile}
								/>
							</div>
						</div>
					</ResponsiveMasonry>
				</div>
			</Slide>
			{radioData.options.length > 3 && !scrollToEnd ? (
				<div className={style.scroll}>
					<div>Scroll</div>
					<i
						className={style.scrollArrow + " fa fa-angle-down"}
						aria-hidden="true"
					></i>
				</div>
			) : (
				""
			)}
		</>
	);
}

export default ImageRadioButton;
